// src/pages/Workers/ExportWorkersExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";

const ExportWorkersExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Manage Workers");

 const t = i18n.t.bind(i18n);

  worksheet.columns = [
    { header: t("common.id"), key: "id", width: 10 },
    { header: t("common.workerName"), key: "name", width: 25 },
    { header: t("common.email"), key: "email", width: 30 },
    { header: t("common.phoneNo"), key: "phone", width: 20 },
    { header: t("common.department"), key: "department", width: 20 },
    { header: t("common.type"), key: "type", width: 15 },
    { header: t("common.shift"), key: "shift", width: 20 },
    { header: t("common.status"), key: "status", width: 15 },
    { header: t("common.registered"), key: "date", width: 25 },
  ];


  worksheet.addRows(data);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "003149" },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Manage_Workers_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportWorkersExcel;
